/* global DetectUserAgent */
import PropTypes from "prop-types";
import LazyLoadVendor from "react-lazyload";

const LazyLoad = ({ lazy = false, once = false, offset = 0, children, overflow = false }) => {
  const loadNow = !lazy || DetectUserAgent.isPrerender();

  if (loadNow) {
    return children;
  }

  return (
    <LazyLoadVendor once={once} offset={offset} overflow={overflow}>
      {children}
    </LazyLoadVendor>
  );
};

LazyLoad.propTypes = {
  lazy: PropTypes.bool,
  once: PropTypes.bool,
  overflow: PropTypes.bool,
  offset: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default LazyLoad;
